// src/platform/config/defaultConfig.ts
var config = {
  isCnApp: process.env.NEXT_PUBLIC_ENVIRONMENT === "china",
  appName: process.env.NEXT_PUBLIC_APP_NAME
};
var defaultConfig_default = config;
export { defaultConfig_default };